<template>
  <div class="shareUnAuthBox">
    <div class="box">
      <div class="top">
        <img class="topImg" src="../../assets/shareUnAuth1.png" alt="" />
        <div class="right">
          <img class="rightImg" src="../../assets/shareUnAuth2.png" alt="" />
          <div class="text">抱歉，您当前无法访问此页面，可能是权限限制或内容已过期</div>
          <div class="sub-title">您可以联系项目所有者以请求访问权限</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup></script>
<style lang="scss" scoped>
  .shareUnAuthBox {
    height: 100%;
    background-color: #e7ecf0;
    position: relative;
    .box {
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);
      .top {
        display: flex;
        gap: 35px;
        .right {
          padding-top: 8px;
          .text {
            font-size: 20px;
            color: #000000;
            line-height: 27px;
            font-weight: bold;
            margin-top: 50px;
          }
          .sub-title {
            font-size: 18px;
            color: #0d76de;
            line-height: 27px;
            margin-top: 25px;
          }
          .rightImg {
            width: 150px;
          }
        }
        .topImg {
          width: 200px;
        }
      }
    }
  }
</style>
